// extracted by mini-css-extract-plugin
export default {"card":"Checkbox_card__lmuil","title":"Checkbox_title__hGCFS","root":"Checkbox_root__ZqUef","label":"Checkbox_label__LPlog"};